:host {
  display: inline-flex;
  align-items: center;
  // gap: var(--omk-dimension-spacing-small);
  --_omk-label-font-family: var(--omk-label-font-family, var(--omk-font-body-normal-font-family));
  --_omk-label-font-size: var(--omk-label-font-size, var(--omk-font-body-normal-font-size));
  --_omk-label-font-style: var(--omk-label-font-style, var(--omk-font-body-normal-font-style));
  --_omk-label-font-weight: var(--omk-label-font-weight, var(--omk-font-body-normal-font-weight));
  --_omk-label-line-height: var(--omk-label-line-height, var(--omk-font-body-normal-line-height));
  --_omk-label-letter-spacing: var(--omk-label-letter-spacing, var(--omk-font-body-normal-letter-spacing));
  --_omk-label-min-height: var(--omk-label-min-height, var(--omk-font-body-normal-line-height));
  --_omk-label-colour: var(--omk-label-colour, var(--omk-colour-text-primary-resting));
  --_omk-label-disabled-colour: var(--omk-label-disabled-colour, var(--omk-colour-text-disabled-resting));

  --_omk-sublabel-font-family: var(--omk-sublabel-font-family, var(--omk-font-body-xsmall-font-family));
  --_omk-sublabel-font-size: var(--omk-sublabel-font-size, var(--omk-font-body-xsmall-font-size));
  --_omk-sublabel-font-weight: var(--omk-sublabel-font-weight, var(--omk-font-body-xsmall-font-weight));
  --_omk-sublabel-line-height: var(--omk-sublabel-line-height, var(--omk-font-body-xsmall-line-height));
  --_omk-sublabel-colour: var(--omk-sublabel-colour, var(--omk-colour-text-primary-resting));
  --_omk-sublabel-disabled-colour: var(--omk-sublabel-disabled-colour, var(--omk-colour-text-disabled-resting));
}


label {
  cursor: pointer;
  .label-text {
    font-family: var(--_omk-label-font-family);
    font-size: var(--_omk-label-font-size);
    font-style: var(--_omk-label-font-style);
    font-weight: var(--_omk-label-font-weight);
    line-height: var(--_omk-label-line-height);
    letter-spacing: var(--_omk-label-letter-spacing);
    min-height: var(--_omk-label-min-height);
    color: var(--_omk-label-colour);
  }

  .sublabel {
    font-family: var(--_omk-sublabel-font-family);
    font-size: var(--_omk-sublabel-font-size);
    font-weight: var(--_omk-sublabel-font-weight);
    line-height: var(--_omk-sublabel-line-height);
    color: var(--_omk-sublabel-colour);
  }

  .hide {
    display: none;
  }
}

:host([disabled]) {
  pointer-events: none;
  .label-text {
    color: var(--_omk-label-disabled-colour);
  }
  .sublabel {
    color: var(--_omk-sublabel-disabled-colour);
  }
}
